import React, { useContext } from "react";
import SelectionItem from "../../SelectionItem";
import ImgEsTypical6Top from "./images/imgEsTypical6Top.png";
import ImgEsTypical8Top from "./images/imgEsTypical8Top.png";
import ImgEsTypical10Top from "./images/imgEsTypical10Top.png";
import ImgEsTypicalBottom from "./images/imgEsTypicalBottom.png";
import "./index.scss";
import { esTypical10Top, esTypical6Top, esTypical8Top, esTypicalBottom } from "./typicalTypes";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const EsteticTypicalSelect = ({
  selectStep
}) => {
  const {
    _t
  } = useTranslation();
  const {
    setPatientFace
  } = useContext(StepContext);
  const types = [{
    key: "esTypical6Top",
    img: ImgEsTypical6Top,
    name: _t("При улыбке видны 6 зубов верхней челюсти")
  }, {
    key: "esTypical8Top",
    img: ImgEsTypical8Top,
    name: _t("При улыбке видны 8 зубов верхней челюсти")
  }, {
    key: "esTypical10Top",
    img: ImgEsTypical10Top,
    name: _t("При улыбке видны 10 зубов верхней челюсти")
  }, {
    key: "esTypicalBottom",
    img: ImgEsTypicalBottom,
    name: _t("При улыбке видны зубы Нижней челюсти")
  }];

  function setStep(key) {
    let updatedData = {};
    let faceType = "face10";

    switch (key) {
      case "esTypical6Top":
        updatedData = esTypical6Top;
        faceType = "face6";
        break;

      case "esTypical8Top":
        updatedData = esTypical8Top;
        faceType = "face8";
        break;

      case "esTypical10Top":
        updatedData = esTypical10Top;
        faceType = "face10";
        break;

      case "esTypicalBottom":
        updatedData = esTypicalBottom;
        faceType = "face20";
        break;

      default:
        break;
    }

    setPatientFace(faceType);
    selectStep(key, updatedData);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "esteticTypicalSelect"
  }, /*#__PURE__*/React.createElement("div", {
    className: "esteticTypicalSelect-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    innerTitle: el.name
  }))));
};

export default EsteticTypicalSelect;